import { z } from 'zod/v4'

export const CampaignStatus = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  CANCELED: 'canceled',
  ARCHIVED: 'archived',
} as const

export const CampaignStatusValidator = z.enum([
  CampaignStatus.ACTIVE,
  CampaignStatus.PAUSED,
  CampaignStatus.CANCELED,
  CampaignStatus.ARCHIVED,
])

export const BudgetValidator = z.object({
  amount: z.number(),
  period: z.enum(['weekly', 'monthly']),
  stripeCustomerId: z.string(),
  stripeSubscriptionId: z.string(),
})

export const CampaignResultsValidator = z.object({
  id: z.string().optional(),
  totalSpend: z.number(),
  impressions: z.number(),
  conversions: z.number(),
  costPerLead: z.number(),
  conversionRate: z.number(),
  costPerConversion: z.number(),
})

export const BaseCampaignValidator = z.object({
  name: z.string(),
  budget: BudgetValidator.optional(),
  status: CampaignStatusValidator.optional(),
  leadTracking: z.string().optional(),
  grid: z.string().optional(),
  library: z.string().optional(),
  createdAt: z.string().optional(),
  results: z.array(CampaignResultsValidator).optional(),
  googleAdsCampaignId: z.string().optional(),
  googleAdsCampaignName: z.string().optional(),
})

export const CampaignValidator = BaseCampaignValidator.extend({
  id: z.string(),
})

export type CampaignStatus = z.infer<typeof CampaignStatusValidator>
export type Budget = z.infer<typeof BudgetValidator>
export type CampaignResults = z.infer<typeof CampaignResultsValidator>
export type BaseCampaign = z.infer<typeof BaseCampaignValidator>
export type Campaign = z.infer<typeof CampaignValidator>
